// extracted by mini-css-extract-plugin
export default {"confirmAction":"_2ptEX1uYDS1Ho7QsK7zCvj","basic":"_2bEdmplmR-3IUT7CDZA-EQ","hideCancel":"_1KSb3zCd5l10FHaR1DOHc2"};